<template>
  <div class="login logregister">
    <div class="app_tit">智呈数据分析应用平台</div>
    <div class="loginForm formbox" v-if="$store.state.showPages==0">
      <div class="loginIcon">用户登录</div>
      <div class="loginContent contentbox">
        <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="0" class="demo-ruleForm" @submit.native.prevent>
          <el-form-item prop="admin">
            <span class="admin">用户名</span>
            <div class="el-input">
              <input type="text" autocomplete="off" placeholder="手机号" class="el-input__inner" v-model="ruleForm.admin">
            </div>
          </el-form-item>
          <el-form-item prop="password">
            <span class="admin">密码</span>
            <div class="el-input el-input--suffix xy_pass">
              <input :type="passType" autocomplete="off" placeholder="密码" class="el-input__inner" v-model="ruleForm.password">
              <span class="el-input__suffix" @click="getPassType">
                <span class="el-input__suffix-inner">
                  <i class="el-input__icon el-icon-sunrise-1" v-show="passType==='password'"></i>
                  <i class="el-input__icon el-icon-sunny" v-show="passType==='text'"></i>
                </span>
              </span>
            </div>
          </el-form-item>
          <el-form-item label=" " class="login_check">
            <div class="loginBtn clearFloat">
              <el-checkbox class="left" v-model="ruleForm.check">记住密码</el-checkbox>
              <span class="right" @click="getLoginIndex(2)">忘记密码?</span>
            </div>
          </el-form-item>
          <!-- <el-form-item label=" " class="login_check">
                        <span class="left" @click="getLoginIndex(1)">注册账号</span>
                    </el-form-item> -->
          <el-form-item>
            <el-button type="primary" class="loginIn" native-type="submit" @click="submitForm()">登录
            </el-button>
            <div class="loginBtn clearFloat">
              <span class="left">您还没有账户?</span>
              <span class="right" @click="getLoginIndex(1)">注册账号</span>
            </div>
            <el-button type="primary" class="loginIn" native-type="submit" @click="getTest" v-if="devShow">测试账号
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="registerForm formbox" v-if="$store.state.showPages==1">
      <div>
        <div class="registerheader clearFix">
          <span class="left">注册账号</span>
          <span class="right" @click="getLoginIndex('0')">上一步</span>
        </div>
        <div class="registerbody">
          <el-form :model="registerForm" :rules="registerules" ref="registerForm" label-width="0" class="demo-registerForm">
            <el-form-item prop="name">
              <el-input v-model="registerForm.name" placeholder="姓名"></el-input>
            </el-form-item>
            <el-form-item prop="company">
              <el-input v-model="registerForm.company" placeholder="公司"></el-input>
            </el-form-item>
            <el-form-item prop="phone">
              <el-input v-model="registerForm.phone" placeholder="手机号"></el-input>
            </el-form-item>
            <el-form-item prop="code" style="display:none;">
              <el-input v-model="registerForm.code" placeholder="验证码">
                <i slot="suffix" class="codebtn" :class="{codeActive:validCode}" @click="getCode">{{codeText}}</i>
              </el-input>
            </el-form-item>
            <el-form-item prop="pass">
              <el-input type="password" v-model="registerForm.pass" autocomplete="new-password" placeholder="密码"></el-input>
            </el-form-item>
            <el-form-item prop="checkPass">
              <el-input type="password" v-model="registerForm.checkPass" autocomplete="off" placeholder="确认密码"></el-input>
            </el-form-item>
            <el-form-item prop="invitationCode">
              <el-input type="password" v-model="registerForm.invitationCode" autocomplete="off" placeholder="邀请码（选填）"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" class="loginIn" @click="submitRegister('registerForm')">注册
              </el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <div class="forgetForm registerForm formbox" v-if="$store.state.showPages==2">
      <div>
        <div class="forgetheader">
          <span class="left">忘记密码</span>
          <span class="right" @click="getLoginIndex(0)">上一步</span>
        </div>
        <div class="forgetbody">
          <el-form :model="forgetForm" :rules="forgetules" ref="forgetForm" label-width="0" class="demo-forgetForm">
            <el-form-item prop="phone">
              <el-input v-model="forgetForm.phone" placeholder="手机号"></el-input>
            </el-form-item>
            <el-form-item prop="code">
              <el-input v-model="forgetForm.code" placeholder="验证码">
                <i slot="suffix" class="codebtn" :class="{codeActive:validCode}" @click="getCode1">{{codeText}}</i>
              </el-input>
            </el-form-item>
            <el-form-item prop="pass">
              <el-input type="password" v-model="forgetForm.pass" autocomplete="new-password" placeholder="密码"></el-input>
            </el-form-item>
            <el-form-item prop="checkPass">
              <el-input type="password" v-model="forgetForm.checkPass" autocomplete="off" placeholder="确认密码"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" class="loginIn" @click="submitforget('forgetForm')">确定</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 @author hjj
 @date 2020/4/21 2:56 下午
 */
import {
  setToken,
  setUser,
  delAllData,
  getToken,
  getUser
} from '@/assets/js/basis'
import {
  getLogin,
  VerifPhone,
  VerificationCode,
  RegistrationUser,
  EditPwd,
} from '@/assets/axios/login/login'
import {
  validateName,
  validateCompany,
  validatePhone,
  validateCode,
  validatePass,
  validatePassTwo
} from '@/assets/common/js/regulars'
import qs from 'qs'
import {
  toMQ,
  closeMQ
} from '@/components/Sock/RabbitMQ'


export default {
  name: 'login',
  components: {},
  props: {},
  data() {

    /*=============登录=================*/
    let adminRUL = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入账号'));
      } else {
        callback();
      }
    };
    let passwordRUL = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        callback();
      }
    };
    /*=============注册=================*/
    let validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        if (this.registerForm.checkPass !== '') {
          this.$refs.registerForm.validateField('checkPass');
        }
        callback();
      }
    };
    // 验证再次输入密码
    let validatePassTwo = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.registerForm.pass) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    let validatePassThree = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.forgetForm.pass) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback(new (''));
      }
    };
    return {
      /*=============登录=================*/
      ruleForm: {
        admin: '',
        password: '',
        check: false
      },
      rules: {
        admin: [
          { validator: adminRUL, trigger: 'blur' }
        ],
        password: [
          { validator: passwordRUL, trigger: 'blur' }
        ],
      },
      passType: 'password',
      loginList: [
        {
          admin: "18635061409",
          password: "123456"
        }
      ],
      devShow: false,
      /*=============注册页=================*/
      validCode: true,
      codeText: '短信发送',
      registerForm: {
        name: '',
        company: '',
        phone: '',
        code: '123456',
        pass: '',
        checkPass: '',
        invitationCode: '',
      },
      registerules: {
        name: [
          { validator: validateName, trigger: 'blur' }
        ],
        company: [
          { validator: validateCompany, trigger: 'blur' }
        ],
        phone: [
          { validator: validatePhone, trigger: 'blur' }
        ],
        code: [
          { validator: validateCode, trigger: 'blur' }
        ],
        pass: [
          { validator: validatePass, trigger: 'blur' }
        ],
        checkPass: [
          { validator: validatePassTwo, trigger: 'blur' }
        ],
      },
      /*=============忘记密码=================*/
      validCode: true,
      codeText: '短信发送',
      forgetForm: {
        phone: '',
        code: '',
        pass: '',
        checkPass: '',
      },
      forgetules: {

        phone: [
          { validator: validatePhone, trigger: 'blur' }
        ],
        code: [
          { validator: validateCode, trigger: 'blur' }
        ],
        pass: [
          { validator: validatePass, trigger: 'blur' }
        ],
        checkPass: [
          { validator: validatePassThree, trigger: 'blur' }
        ],

      },
    }

  },
  methods: {

    // 切换登录/注册页面
    getLoginIndex(index) {
      if (index === this.$store.state.showPages) {
        return;
      }
      this.$store.state.showPages = index;
      log(this.registerForm)
    },
    /*=============登录=================*/
    //获取login参数
    getParams() {
      //清除cookie，每次进入带上token进行登陆
      delAllData();
      this.getCookieLogin();
      if (process.env.NODE_ENV === 'development') {
        this.devShow = true;
      }
    },
    //测试用账号密码
    getUser(type) {
      this.ruleForm.admin = this.loginList[type].admin;
      this.ruleForm.password = this.loginList[type].password;
    },
    //获取用户名密码
    getCookieLogin() {
      let loginName_xy = this.getCookie('FFName_xy');
      let loginPassword_xy = this.getCookie('FFPwd_xy');
      if (loginName_xy && loginPassword_xy) {
        this.ruleForm = {
          admin: loginName_xy,
          password: loginPassword_xy,
          check: true
        }
      } else {
        this.ruleForm = {
          admin: this.$store.state.user.phone,
          password: this.$store.state.user.password,
          check: false
        }
      }
    },
    //忘记密码
    submitforget() {
      EditPwd({
        phone: this.forgetForm.phone,
        newPwd: "123456",
        verificationCode: this.forgetForm.pass,
      }).then(res => {
        if (res.code == 200) {
          this.getMsg('修改成功', 'success');
        }
      })
    },
    //提交
    async submitForm() {

      if (!this.ruleForm.admin) {
        this.getMsg('请输入账号', 0, 1000);
        return;
      }
      if (!this.ruleForm.password) {
        this.getMsg('请输入密码', 0, 1000);
        return;
      }
      let today = new Date();
      let licTime = new Date("2099-08-01 00:00:00");
      if (today > licTime) {
        alert("您的授权已到期，请联系管理员！");
      } else {
        getLogin({
          phone: this.ruleForm.admin,
          password: this.ruleForm.password,
        }).then(res => {
          if (res.code === 200) {
            if (this.ruleForm.check) {
              this.setCookie('FFName_xy', this.ruleForm.admin, 7);
              this.setCookie('FFPwd_xy', this.ruleForm.password, 7);
            } else {
              this.delCookie(['FFName_xy', 'FFPwd_xy']);
            }
            setToken(res.data.token);
            setUser(res.data.user);
            this.getRouterPath('/rearMain');
            toMQ(res.data.user.id);
          }
        }).catch(() => {
          this.getMsg('错误 服务器异常！');
        });
      }


    },
    //重置
    resetForm() {
      this.ruleForm.admin = '';
      this.ruleForm.password = '';
    },
    //查看密码
    getPassType() {
      if (this.passType === 'password') {
        this.passType = 'text'
      } else if (this.passType === 'text') {
        this.passType = 'password'
      } else {
        this.passType = 'password'
      }
    },
    //测试账号
    getTest() {
      this.ruleForm.admin = 'admin';
      this.ruleForm.password = '135790';
    },
    /*=============注册=================*/
    // 注册
    submitRegister(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          RegistrationUser({
            userName: this.registerForm.name,
            phone: this.registerForm.phone,
            company: this.registerForm.company,
            password: this.registerForm.pass,
            verification: this.registerForm.code,
            invitationCode: this.registerForm.invitationCode
          }).then(res => {
            if (res.code == 200) {
              this.getMsg('注册成功', 'success');
              let loginName_xy = this.getCookie('FFName_xy');
              let loginPassword_xy = this.getCookie('FFPwd_xy');
              if (loginName_xy && loginPassword_xy) {
                this.delCookie(['FFName_xy', 'FFPwd_xy']);
              }

              this.$store.state.user.phone = this.registerForm.phone;
              this.$store.state.user.password = this.registerForm.pass;
              this.getLoginIndex(0)
            } else {
              this.getMsg(res.message, 0, 1000);
            }
          })

        } else {
          this.registerForm.phone = ""
          return false;
        }
      });
    },
    // 获取验证码
    getCode() {
      if (!this.registerForm.phone) {
        this.getMsg('请先输入手机号码', 0, 1000);
        return;
      } else {
        if (/^[1][3,4,5,7,8][0-9]{9}$/.test(this.registerForm.phone)) {
          let _this = this;
          let timer = "";
          let nums = 60;
          if (_this.validCode) {
            //验证手机号
            VerifPhone({
              phone: this.registerForm.phone
            }).then(res => {
              if (res.code != 200) {
                return;
              } else {
                _this.validCode = false;
                timer = setInterval(function () {
                  if (nums > 0) {
                    nums--;
                    _this.codeText = nums + "秒";

                  } else {
                    clearInterval(timer);
                    nums = 60;//重置回去
                    _this.validCode = true;
                    _this.codeText = "短信发送";
                  }
                }, 1000)
                // 获取验证码
                VerificationCode({
                  phone: _this.registerForm.phone
                }).then(res => {
                  if (res.code == 200) {
                    _this.registerForm.code = res.data.dataTabel;
                  }
                })
              }
            })
          }
        } else {
          this.getMsg('请输入正确手机号', 0, 1000);
        }
      }
    },
    getCode1() {
      if (!this.forgetForm.phone) {
        this.getMsg('请先输入手机号码', 0, 1000);
        return;
      } else {
        if (/^[1][3,4,5,7,8][0-9]{9}$/.test(this.forgetForm.phone)) {
          let _this = this;
          let timer = "";
          let nums = 60;
          if (_this.validCode) {
            //验证手机号
            VerifPhone({
              phone: ""
            }).then(res => {
              if (res.code != 200) {
                return;
              } else {
                _this.validCode = false;
                timer = setInterval(function () {
                  if (nums > 0) {
                    nums--;
                    _this.codeText = nums + "秒";
                  } else {
                    clearInterval(timer);
                    nums = 60;//重置回去
                    _this.validCode = true;
                    _this.codeText = "短信发送";
                  }
                }, 1000)
                // 获取验证码
                VerificationCode({
                  phone: _this.forgetForm.phone
                }).then(res => {
                  if (res.code == 200) {
                    _this.forgetForm.code = res.data.dataTabel;
                  }
                })
              }
            })
          }
        } else {
          this.getMsg('请输入正确手机号', 0, 1000);
        }
      }
    },
  },
  mounted() {
    this.getParams();
  },
  destroyed() {

  }
}
</script>

<style lang="less">
.login {
  background: url("../../../public/image/login_bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  @font-face {
    font-family: "华康新综艺";
    src: url("../../../theme/fonts/huakangxinzongyi.ttf");
  }
  .app_tit {
    position: absolute;
    top: 10%;
    left: 50%;
    transform: translateX(-50%);
    font-size: 66px;
    text-shadow: 2px 5px 1px #000;
    text-align: center;
    font-family: "华康新综艺";
  }
  .app_tit::after {
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    content: "智呈数据分析应用平台";
    background: linear-gradient(to bottom, #01f8fa, #0090db);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    text-shadow: none;
    font-family: "华康新综艺";
  }
  .forgetbody {
    .el-input {
      width: 100% !important;
    }
  }
  .registerForm {
    .el-input {
      width: 100% !important;
    }
  }
  .loginForm {
    padding: @WhiteSpace;
    background: url("../../../public/image/register_bg.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center;
    .el-input {
      width: 100% !important;
    }

    .loginIcon {
      margin: 0 auto;
      text-align: center;
      font-size: 22px;
      color: #00fefe;
    }

    .loginContent {
      margin-top: 30px;
      .admin {
        color: #fff;
      }
    }

    .loginBtn {
      > .left {
        color: #fff;
        font-size: 12px;
      }

      > .right {
        color: #13b5b1;
        font-size: 12px;
      }
      > .right:hover {
        color: #00fdfe;
      }
    }
  }

  .registerForm {
    background: url("../../../public/image/register_bg.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center;
    div {
      .registerheader {
        padding: 26px 30px 0;
        font-size: 14px;

        .left {
          color: #fff;
        }

        .right {
          color: @pagBackcolor;
          cursor: pointer;
        }

        .right:hover {
          color: @green;
        }
      }

      .registerbody {
        padding: @WhiteSpace;
      }
    }
  }

  .forgetForm {
    background: url("../../../public/image/register_bg.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center;

    div {
      .forgetheader {
        padding: 26px 30px 0;
        font-size: 14px;
        .left {
          color: #fff;
        }

        .right {
          color: @green;
          cursor: pointer;
        }

        .right:hover {
          color: #00fdfe;
        }
      }

      .forgetbody {
        padding: @WhiteSpace;
      }
    }
  }

  .loginIn {
    margin-left: 0 !important;
  }
  .el-checkbox__input + .el-checkbox__label {
    color: #fff !important;
  }
}
</style>